import { render, staticRenderFns } from "./teacherSetting.vue?vue&type=template&id=354fcc3f&scoped=true"
import script from "./teacherSetting.vue?vue&type=script&lang=js"
export * from "./teacherSetting.vue?vue&type=script&lang=js"
import style0 from "./teacherSetting.vue?vue&type=style&index=0&id=354fcc3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fcc3f",
  null
  
)

export default component.exports